import React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';

const Pagination = ({ 
    totalPages = 1, 
    currentPage = 1, 
    onPageChange, 
    size,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    const items = [];
    
    for (let number = 1; number <= totalPages; number++) {
        items.push(
            <BootstrapPagination.Item 
                key={number} 
                active={number === currentPage}
                onClick={() => onPageChange && onPageChange(number)}
            >
                {number}
            </BootstrapPagination.Item>
        );
    }

    return (
        <BootstrapPagination size={size} className={className} style={style} {...props}>
            <BootstrapPagination.First 
                disabled={currentPage === 1}
                onClick={() => onPageChange && onPageChange(1)} 
            />
            <BootstrapPagination.Prev 
                disabled={currentPage === 1}
                onClick={() => onPageChange && onPageChange(currentPage - 1)} 
            />
            {items}
            <BootstrapPagination.Next 
                disabled={currentPage === totalPages}
                onClick={() => onPageChange && onPageChange(currentPage + 1)} 
            />
            <BootstrapPagination.Last 
                disabled={currentPage === totalPages}
                onClick={() => onPageChange && onPageChange(totalPages)} 
            />
        </BootstrapPagination>
    );
};

export default Pagination;

